import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { UnespCoreEnvironment } from '@unesp/core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'
import { DiscenteDisciplina } from '../models/discente-disciplina'
import { StatusResponse } from '../models/status-response'
import { CargaHoraria } from '../models/carga-horaria'
import { CargaHorariaCompleto } from '../models/carga-horaria-completo'
import { Relatorio } from '../models/relatorio'
import { RelatorioForm } from '../models/relatorio-form'
import { StatusInscricao } from '../models/status-inscricao'
import { PlanoEntregue } from '../models/plano-entregue'
import { RelatorioEntregue } from '../models/relatorio-entregue'

@Injectable({
  providedIn: 'root',
})
export class DocenteService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  aprovarCargaHoraria(idDepartamentoSecao: number, ano: number): Observable<DiscenteDisciplina[]> {
    return this.http
      .get<DiscenteDisciplina[]>(`${this.baseUrl}/docente/aprovar-carga-horaria/${idDepartamentoSecao}/${ano}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  cargaHorariaEfetiva(idInscricao: number): Observable<CargaHorariaCompleto> {
    return this.http.get<CargaHorariaCompleto>(`${this.baseUrl}/docente/aprovar-carga-horaria/${idInscricao}`)
  }

  registrarCargaHorariaEfetiva(idInscricao: number, data: CargaHoraria[]): Observable<StatusResponse> {
    return this.http
      .post<StatusResponse>(`${this.baseUrl}/docente/aprovar-carga-horaria/${idInscricao}`, data)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  aprovarRelatorioAtividades(idDepartamentoSecao: number, ano: number): Observable<DiscenteDisciplina[]> {
    return this.http
      .get<DiscenteDisciplina[]>(`${this.baseUrl}/docente/aprovar-relatorio-atividades/${idDepartamentoSecao}/${ano}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  analisarRelatorioAtividades(id: number): Observable<Relatorio> {
    return this.http
      .get<Relatorio>(`${this.baseUrl}/docente/aprovar-relatorio-atividades/${id}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  registrarAnaliseRelatorioAtividades(id: number, form: RelatorioForm): Observable<StatusResponse> {
    return this.http
      .post<StatusResponse>(`${this.baseUrl}/docente/aprovar-relatorio-atividades/${id}`, form)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  emissaoCertificado(idDepartamentoSecao: number, cpf: string, ano: number): Observable<DiscenteDisciplina[]> {
    return this.http
      .get<DiscenteDisciplina[]>(`${this.baseUrl}/docente/emissao-certificado/${idDepartamentoSecao}/${cpf}/${ano}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  certificado(id: number): Observable<any> {
    let headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    })
    let requestOptions = { headers: headerOptions, responseType: 'blob' as 'blob' }
    return this.http
      .get(`${this.baseUrl}/docente/emissao-certificado/${id}`, requestOptions)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  planoEntregue(idDepartamentoSecao: number, cpf: string, ano: number): Observable<PlanoEntregue[]> {
    return this.http
      .get<PlanoEntregue[]>(`${this.baseUrl}/docente/plano-entregue/${idDepartamentoSecao}/${cpf}/${ano}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  relatorioEntregue(idDepartamentoSecao: number, cpf: string, ano: number): Observable<RelatorioEntregue[]> {
    return this.http
      .get<RelatorioEntregue[]>(`${this.baseUrl}/docente/relatorio-entregue/${idDepartamentoSecao}/${cpf}/${ano}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  statusInscricao(idDepartamentoSecao: number, cpf: string, ano: number): Observable<StatusInscricao[]> {
    return this.http
      .get<StatusInscricao[]>(`${this.baseUrl}/docente/status-inscricao/${idDepartamentoSecao}/${cpf}/${ano}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  download(folder: string, idInscricao: number): Observable<any> {
    let headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    })
    let requestOptions = { headers: headerOptions, responseType: 'blob' as 'blob' }
    return this.http
      .get(`${this.baseUrl}/docente/download/${folder}/${idInscricao}`, requestOptions)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
